import olms, {apply, applyBackground, applyStyle} from './index';
import stylefunction from './stylefunction';

olms.apply = apply;
olms.applyBackground = applyBackground;
olms.applyStyle = applyStyle;
olms.stylefunction = stylefunction;

export default olms;
